import '@one/icons/dist/one-icons-filled.css';
import '@one/icons/dist/one-icons-outlined.css';
import '@one/roche-font/roche-font.css';
import '@one/web-components/dist/owc/owc.css';
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  body {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    margin: 0;
    overflow: hidden;
    font-family: 'Roche Sans', Roboto,  Helvetica, Arial, sans-serif;
    font-style: normal;
    background-color: var(--one-color-gray-50);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    header {
      width: 100%;
    }

    owc-theme-provider {
      width: 100%;
      height: 100%;
    }

    #root {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
    }
  }

  * {
    box-sizing: border-box;

    /* color : var(--one-color-black-800); */
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  a {
    color: #00f; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
  }

  .link-appearance {
    color: var(--one-color-interaction-default-brand-base);
  }

  owc-typography[variant="subtitle2"] {
    color: var(--one-color-gray-600);
  }

  .red-text {
    color: var(--one-color-interaction-default-negative-base);
  }

  /* OWC-OVERRIDE: custom notification-drawer top-right positioning (project layout, not an owc
     default) so toasts clear the app header. owc-notification-drawer exposes only preset
     placements in v7.6.0, none of which take an offset. Revisit on the next @one upgrade. */
  .owc-notification-drawer .owc-notification-drawer__top-right-drawer {
    top: 4rem;
    right: 24px;
  }

  /* A toast relocated with its drawer (when its overlay closes) must not replay its slide-in — see
     notification-service. The exit animation still runs once owc-snackbar adds "close-requested". */
  owc-snackbar.poc-toast-relocated:not(.close-requested) {
    animation: none;
  }

  /* OWC-OVERRIDE: owc-snackbar has no native max-width in v7.6.0 (it spans the full viewport)
     and no width prop; cap it to ~50% and centre the icon in the banner prefix slot, whose
     alignment owc sets at a specificity that needs !important. Revisit on the next @one upgrade. */
  .owc-snackbar {
    width: unset;
    min-width: 0;
    max-width: calc(50% - 0.5rem);

    .owc-banner__top-wrapper__top-left-wrapper__prefix-wrapper {
      align-items: center !important;
      width: 50px;
    }
  }

  /* OWC-OVERRIDE: owc-backdrop's z-index is auto in v7.6.0 (below the app header at 10101);
     raise it so modal backdrops cover the header. No z-index prop. Revisit on the next @one upgrade. */
  .owc-backdrop {
    z-index: 1000000;
  }

  /* OWC-OVERRIDE: owc-tooltip has no native max-width or wrapping in v7.6.0, so long messages
     render as one unbroken line; cap the width and wrap. No width/wrap prop. Revisit on the next @one upgrade. */
  owc-tooltip{
    max-width: 292px;

    .owc-tooltip__body{
        overflow-wrap: break-word;
    }

  }

  /* OWC-OVERRIDE: owc-backdrop clips its content, which hides it from automated UI tests;
     force it visible. owc-backdrop exposes no overflow prop in v7.6.0 and !important is
     needed to beat its own rule. Revisit on the next @one upgrade. */
  .owc-backdrop__backdrop-content {
    overflow: visible !important;
  }

  #ot-sdk-btn {
    margin-bottom: 16px;
    background-color: unset !important;

    &:hover {
        background-color: var(--one-color-interaction-hover-brand-lower) !important;
    }
  }

`;
